import FulfillmentProductIndexPage from "./FulfillmentProductIndexPage";
export default FulfillmentProductIndexPage;
